<template>
    <div style="height: 100%">
        <div class="sa-flexbox" style="padding-bottom: 20px">
            <div class="sa-flexbox-body">
                <div class="b-table-sticky-header">
                    <span class="sa-flexbox-body-title">Fatturazione</span>
                    <b-table sticky-header ref="table" stacked="lg" striped hover :items="items" :fields="fields" :current-page="1" :per-page="perPage" :key="listKey" sort-icon-left head-variant="light" class="sa-b-table">
                        <template #cell(index)="row">
                            {{ (currentPage - 1) * perPage + row.index + 1 }}
                        </template>
                        <template #cell(meseAnnoRiferimento)="{ item }">
                            {{ formatDateTimeCustom(item.meseAnnoRiferimento, "MMM-yyyy") }}
                        </template>
                        <template #cell(createDate)="{ item }">
                            {{ formatDateTime(item.createDate) }}
                        </template>
                        <template v-slot:cell(actions)="row">
                            <b-container class="bv-example-row">
                                <b-button size="sm" variant="outline-purple no-text" title="Stampa Documento" style="margin-right: 5px" @click="onStampa(row.item)">
                                    <b-icon icon="printer"></b-icon>
                                </b-button>
                                <b-button size="sm" variant="outline-info no-text" title="Scarica XML" @click="onDownload(row.item)">
                                    <b-icon icon="download"></b-icon>
                                </b-button>
                                <b-button size="sm" v-b-tooltip.hover title="Visualizza Documento" variant="outline-secondary no-text" @click="onClickView(row.item)" class="mr-1 no-text">
                                    <font-awesome-icon icon="eye" />
                                </b-button>
                            </b-container>
                        </template>
                    </b-table>
                </div>
            </div>
            <div class="d-flex flex-column">
                <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                    <b-col lg="3">
                        <p>Records Totali: {{ rows }}</p>
                    </b-col>

                    <b-col lg="9">
                        <b-pagination :total-rows="rows" v-model="currentPage" :per-page="perPage" align="right" size="sm"> </b-pagination>
                    </b-col>
                </b-row>
            </div>
        </div>
        <b-modal ref="mdlStampaReferto" size="xl" style="height: 100%">
            <b-embed type="iframe" :src="stampaReport" allowfullscreen></b-embed>
        </b-modal>
    </div>
</template>

<script>
import UtilityMixin from "../../../utility/UtilityMixin";

import axios from "axios";
import moment from "moment";

export default {
    mixins: [UtilityMixin],
    components: {},
    data() {
        return {
            items: [],
            rows: 0,
            storicoMode: false,
            perPage: 50,
            idLetto: null,
            currentPage: 1,
            filtro: {},
            pathResource: "/rsafatturazionerichiestefatture",
            pathResourceDocumenti: "/documenti",
            pathResourceStampa: "/print/createreport",
            stampaReport: null,
            reportName: "documenti",
            linkFatturaElettronica: "/documenti/fatturaelettronica",
            idRichiesta: null,
            endpoint: null,
            listKey: 0,
            fields: [
                {
                    label: this.$i18n.t("billing.lblDate"),
                    key: "dataDocumento",
                    sortable: true,
                    thStyle: "width: 7rem",
                    formatter: (value) => {
                        return moment(new Date(value)).format("DD-MM-YYYY");
                    },
                },
                {
                    label: "Num.",
                    key: "numeroDocumento",
                    thStyle: "width: 5rem",
                    sortable: true,
                },
                {
                    label: this.$i18n.t("billing.lblDocumentType"),
                    key: "tipoDocumentoDescrizione",
                    thStyle: "width: 14rem",
                    sortable: true,
                },
                {
                    label: this.$i18n.t("billing.lblCompanyName"),
                    key: "cognomeRagioneSoggetto",

                    sortable: true,
                },
                {
                    label: "Nome",
                    key: "nomeSoggetto",

                    sortable: true,
                },
                {
                    //label: this.$i18n.t("billing.lblTotaleDocumento"), <- Correggere su Traduora
                    label: "Totale",
                    key: "totaleDocumento",
                    sortable: true,
                    formatter: (value) => value.toLocaleString("it-IT", { style: "currency", currency: "EUR" }),
                    thStyle: "width: 7rem",
                },
                { class: "sa-table-column-action-double", key: "actions", label: "" },
            ],
        };
    },
    watch: {
        currentPage() {
            let me = this;
            me.loadData();
        },
    },
    methods: {
        onStampa(row) {
            let me = this;
            // console.log(row);
            let link = process.env.VUE_APP_PATH_API + me.pathResourceDocumenti + "/" + row.idDocumento;
            axios.get(link).then((response) => {
                let printData = response.data.data;
                let linkReport = process.env.VUE_APP_PATH_API + me.pathResourceStampa;
                axios.post(linkReport, { reportName: me.reportName, data: printData }).then((response) => {
                    me.$refs.mdlStampaReferto.show();
                    me.stampaReport = "data:application/pdf;base64," + response.data.base64;
                });
            });
        },
        onDownload(row) {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.linkFatturaElettronica + "/" + row.idDocumento;
            axios({
                url: link, //your url
                method: "GET",
                responseType: "blob", // important
            }).then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement("a");
                link.href = url;
                let nomeFile = row.numeroDocumento + "_" + moment(row.dataDocumento).format("DD-MM-YYYY");
                link.setAttribute("download", nomeFile + ".xml"); //or any other extension
                document.body.appendChild(link);
                link.click();
            });
        },
        init(idRichiesta) {
            let me = this;
            me.idRichiesta = idRichiesta;
            me.loadData();
        },
        onClickView(item) {
            // console.log(item);
            let me = this;
            me.$router.push("/contabilita/fatturazione/view/" + item.idDocumento);
        },
        loadData() {
            let me = this;
            me.filtro.page = me.currentPage;
            me.filtro.forPage = me.perPage;
            me.filtro.idRichiesta = me.idRichiesta;
            UtilityMixin.methods.loadDataResources(me.pathResource, me.filtro, me.loadDataSuccess, me.loadDataError);
        },
        loadDataSuccess(response) {
            let me = this;
            me.items = response.data.data.list;
            me.$emit("afterLoadData");
            me.rows = response.data.data.recordsNumber;
            me.listKey++;
        },
        loadDataError(response) {
            let me = this;
            me.$emit("afterLoadData", response);
            me.$bvToast.toast("Errore durante il caricamento", {
                title: "Errore",
                variant: "danger",
                solid: true,
            });
        },
        onAfterSave() {
            let me = this;
            me.loadData();
        },
    },
};
</script>

<style></style>
